module.exports = __webpack_public_path__ + "img/buho.593db190.png";